/**
 * 指摘対象 申請用モジュール
 */

import { ThunkAction } from 'redux-thunk';

import { ApplyContent, apply } from '../services/contractApi';
export { ApplyContent } from '../services/contractApi';

export interface ApplyState {
  contents: (ApplyContent | null)[];
  successMessages: string[];
  errorMessages: string[];
  status: number;
}

const initialState: ApplyState = {
  contents: [],
  successMessages: [],
  errorMessages: [],
  status: 0,
};

const CHANGE_APPLY_CONTENT = 'CHANGE_APPLY_CONTENT';
type CHANGE_APPLY_CONTENT = typeof CHANGE_APPLY_CONTENT;

const CHANGE_CATEGORY = 'CHANGE_CATEGORY';
type CHANGE_CATEGORY = typeof CHANGE_CATEGORY;

const REQUEST_APPLY = 'REQUEST_APPLY';
type REQUEST_APPLY = typeof REQUEST_APPLY;

const SUCCESS_APPLY = 'SUCCESS_APPLY';
type SUCCESS_APPLY = typeof SUCCESS_APPLY;

const FAIL_APPLY = 'FAIL_APPLY';
type FAIL_APPLY = typeof FAIL_APPLY;

const CLEAR_APPLY = 'CLEAR_APPLY';
type CLEAR_APPLY = typeof CLEAR_APPLY;

const CLEAR_APPLY_CONTENTS = 'CLEAR_APPLY_CONTENTS';
type CLEAR_APPLY_CONTENTS = typeof CLEAR_APPLY_CONTENTS;

const CLEAR_APPLY_SUCCESS_MESSAGES = 'CLEAR_APPLY_SUCCESS_MESSAGES';
type CLEAR_APPLY_SUCCESS_MESSAGES = typeof CLEAR_APPLY_SUCCESS_MESSAGES;

const CLEAR_APPLY_ERROR_MESSAGES = 'CLEAR_APPLY_ERROR_MESSAGES';
type CLEAR_APPLY_ERROR_MESSAGES = typeof CLEAR_APPLY_ERROR_MESSAGES;

interface ChangeApplyContent {
  type: CHANGE_APPLY_CONTENT;
  content: ApplyContent;
}

interface ChangeCategory {
  type: CHANGE_CATEGORY;
  content: ApplyContent;
  index: number;
}

interface RequestApply {
  type: REQUEST_APPLY;
}

interface SuccessApply {
  type: SUCCESS_APPLY;
  successMessages: string[];
}

interface FailApply {
  type: FAIL_APPLY;
  status: number;
  errorMessages: string[];
}

interface ClearApply {
  type: CLEAR_APPLY;
}

interface ClearApplyContents {
  type: CLEAR_APPLY_CONTENTS;
}

interface ClearApplySuccessMessages {
  type: CLEAR_APPLY_SUCCESS_MESSAGES;
}

interface ClearApplyErrorMessages {
  type: CLEAR_APPLY_ERROR_MESSAGES;
}

export type ContractAction = ChangeApplyContent | ChangeCategory | RequestApply |
  SuccessApply | FailApply | ClearApplyContents | ClearApply |
  ClearApplySuccessMessages | ClearApplyErrorMessages;

type Apply =
  ThunkAction<void, ApplyState, undefined, ContractAction>;

export function changeApplyContent(
  content: ApplyContent,
): ChangeApplyContent {
  return {
    content,
    type: CHANGE_APPLY_CONTENT,
  };
}

export function changeCategory(
  index: number,
  content: ApplyContent,
): ChangeCategory {
  return {
    index,
    content,
    type: CHANGE_CATEGORY,
  };
}

export function requestApply(): RequestApply {
  return {
    type: REQUEST_APPLY,
  };
}

export function successApply(successMessages: string[]): SuccessApply {
  return {
    successMessages,
    type: SUCCESS_APPLY,
  };
}

export function failApply(errorMessages: string[], status: number): FailApply {
  return {
    errorMessages,
    status,
    type: FAIL_APPLY,
  };
}

export function clearApplyContents(): ClearApplyContents {
  return {
    type: CLEAR_APPLY_CONTENTS,
  };
}

export function clearApply(): ClearApply {
  return {
    type: CLEAR_APPLY,
  };
}

export function clearApplySuccessMessages(): ClearApplySuccessMessages {
  return {
    type: CLEAR_APPLY_SUCCESS_MESSAGES,
  };
}

export function clearApplyErrorMessages(): ClearApplyErrorMessages {
  return {
    type: CLEAR_APPLY_ERROR_MESSAGES,
  };
}

export function submitApplyContents(name: string, contents: ApplyContent[]): Apply {
  return (dispatch) => {
    dispatch(requestApply());
    // 登録API呼び出し
    return apply(name, contents).then((res) => {
      const { status, result, messages, status_code } = res;
      if (status === 200 && result) {
        dispatch(successApply(messages));
      } else {
        dispatch(failApply(messages, status_code));
      }
    }).catch((err) => {
      dispatch(failApply([String(err)], 500));
    });
  };
}

export default function reducer(
  state: ApplyState | undefined,
  action: ContractAction,
): ApplyState {
  if (!state) return initialState;
  switch (action.type) {
    case CHANGE_APPLY_CONTENT: {
      const { content } = action;
      const contents = [...state.contents];
      // すでに選択されたコンテンツの中から、今選択されたコンテンツを特定する
      const keys = Object.keys(contents).filter((i) => {
        return content.fileName === contents[i].fileName &&
          content.orgTagId === contents[i].orgTagId &&
          content.position === contents[i].position &&
          content.order === contents[i].order;
      });
      if (keys.length === 0) {
        contents.push(content); // new
      } else {
        // 今選択されたコンテンツは1つだけなので0番目のみ参照
        contents.splice(+keys[0], 1); // delete
      }
      return { ...state, contents };
    }
    case CHANGE_CATEGORY: {
      const { index, content } = action;
      const contents = [...state.contents];
      contents[index] = content; // update
      return { ...state, contents };
    }
    case REQUEST_APPLY: {
      return state;
    }
    case SUCCESS_APPLY: {
      return { ...state, successMessages: ['指摘内容を送信しました。'] };
    }
    case FAIL_APPLY: {
      const { errorMessages, status } = action;
      return { ...state, errorMessages, status };
    }
    case CLEAR_APPLY_CONTENTS: {
      return { ...state, contents: [] };
    }
    case CLEAR_APPLY_SUCCESS_MESSAGES: {
      return { ...state, successMessages: [] };
    }
    case CLEAR_APPLY_ERROR_MESSAGES: {
      return { ...state, errorMessages: [] };
    }
    case CLEAR_APPLY: {
      return initialState;
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/apply.ts